// These should be considered Constants that define
// how the message types affect the UI display
import DateService from "../src/Services/Shared/Date.service";
export const SEND_TO_SELECTED_RECIPIENTS_FROM_THREAD_ID = 0;
export const SEND_TO_SELECTED_RECIPIENTS_ID = 1;
export const SEND_TO_ALL_STUDENTS_ON_MY_CASELOAD_ID = 2;
export const SEND_TO_STUDENTS_ON_MY_CASELOAD_WITH_SELECTED_TAGS_ID = 3;
export const SEND_TO_STUDENTS_ON_MY_CASELOAD_WITH_SELECTED_PROGRAMS_ID = 4;
export const SEND_TO_STUDENTS_ON_MY_CASELOAD_WITH_SELECTED_DEGREES_ID = 5;
export const SEND_TO_RECIPIENTS_FROM_LIST_IDS_ID = 6;
export const SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_ID = 7;
export const SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_TAGS_ID = 8;
export const SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_PROGRAMS_ID = 9;
export const SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_DEGREES_ID = 10;
export const SEND_TO_ALL_STUDENTS_ON_MY_ROSTER_ID = 11;
export const SEND_TO_ALL_STUDENTS_ON_MY_CASELOAD_WITH_SELECTED_TERM_RISK_LEVELS = 12;
export const SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_TERM_RISK_LEVELS = 13;
export const SEND_TO_ALL_STUDENTS_IN_SELECTED_COURSE_SECTIONS = 14;
export const SEND_TO_ALL_STUDENTS_ON_MY_CASELOAD_WITH_SELECTED_COURSE_RISK_LEVELS = 15;
export const SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_COURSE_RISK_LEVELS = 16;
export const SEND_TO_ALL_STUDENTS_WITH_SELECTED_APPLICATION_STATUS_AND_TERM = 17;
export const SEND_TO_FILTER = 18;
export const warnMessageTypes = [
    SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_ID,
    SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_TAGS_ID,
    SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_PROGRAMS_ID,
    SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_DEGREES_ID,
    SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_TERM_RISK_LEVELS,
    SEND_TO_ALL_CURRENTLY_ATTENDING_STUDENTS_WITH_SELECTED_COURSE_RISK_LEVELS,
    SEND_TO_ALL_STUDENTS_IN_SELECTED_COURSE_SECTIONS,
    SEND_TO_ALL_STUDENTS_WITH_SELECTED_APPLICATION_STATUS_AND_TERM,
    SEND_TO_FILTER,
];
// @ts-expect-error - TS7006 - Parameter 'form' implicitly has an 'any' type.
export const mapRecipientsByMessageType = (form) => {
    // SET AFFILIATION IDS
    let affiliationIds = [];
    // affiliation id
    switch (form.to.value) {
        case SEND_TO_SELECTED_RECIPIENTS_ID:
            // @ts-expect-error - TS7006 - Parameter 'recipient' implicitly has an 'any' type.
            affiliationIds = form.sendToRecipients.map((recipient) => ({
                id: recipient.affiliationId,
            }));
            break;
        default:
            affiliationIds = [];
    }
    return affiliationIds;
};
// @ts-expect-error - TS7006 - Parameter 'form' implicitly has an 'any' type.
export const mapMessageForm = (form) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const message = {};
    // SET MESSAGE TYPE
    message.messageType = form.to.isFilter ? SEND_TO_FILTER : form.to.value;
    // SET FROM EMAIL ADDRESS
    message.fromPersonId = (_a = form.fromEmailAddress) === null || _a === void 0 ? void 0 : _a.personId;
    // SET NOTE TYPE
    message.noteTypes =
        // @ts-expect-error - TS7006 - Parameter 'noteType' implicitly has an 'any' type.
        ((_b = form.selectedNoteTypes) === null || _b === void 0 ? void 0 : _b.map((noteType) => noteType.id)) || [];
    // SET TEMPLATE
    message.messageTemplateId = ((_c = form.template) === null || _c === void 0 ? void 0 : _c.messageTemplateId) || "";
    // SET INCLUDE SUBSCRIBERS
    message.includeSubscribers = form.includeSubscribers || false;
    // SET TAG FILTER MODE
    message.tagFilterMode = form.rbTagsAnyAll;
    // SET TAGS
    // @ts-expect-error - TS7006 - Parameter 'tag' implicitly has an 'any' type.
    message.toTagIds = ((_d = form.tags) === null || _d === void 0 ? void 0 : _d.map((tag) => tag.id)) || [];
    // SET PROGRAM IDS
    // @ts-expect-error - TS7006 - Parameter 'program' implicitly has an 'any' type.
    message.toProgramIds = ((_e = form.toPrograms) === null || _e === void 0 ? void 0 : _e.map((program) => program.value)) || [];
    // SET DEGREES
    // @ts-expect-error - TS7006 - Parameter 'degree' implicitly has an 'any' type.
    message.toDegreeIds = ((_f = form.toDegrees) === null || _f === void 0 ? void 0 : _f.map((degree) => degree.value)) || [];
    // SET TERM RISK LEVELS
    // @ts-expect-error - TS7006 - Parameter 'level' implicitly has an 'any' type.
    message.toTermRiskLevelIds = ((_g = form.persistence) === null || _g === void 0 ? void 0 : _g.map((level) => level.id)) || [];
    // SET COURSE RISK LEVELS
    message.toCourseRiskLevelIds =
        // @ts-expect-error - TS7006 - Parameter 'level' implicitly has an 'any' type.
        ((_h = form.toCourseRiskLevels) === null || _h === void 0 ? void 0 : _h.map((level) => level.id)) || [];
    message.studentSearchFilter = form.to.isFilter ? form.to.value : null;
    message.applicationStatuses = form.applicationStatus || [];
    message.applicationTerms = form.applicationTerm || [];
    message.attachmentsIdList = [];
    message.toRecipientsFromListDetail = [];
    message.toRecipientsFromListIds = [];
    // SET SUBJECT
    message.subject = form.subject || "";
    message.sendAsNote = !!(form.noteTypes && form.noteTypes.length);
    if (form.isEmail === "true") {
        message.body = form.body;
        message.sendToInstitutional = form.sendToInstitutional;
        message.sendToPersonal = form.sendToPersonal;
        message.sendAsSms = false;
        // TEMPLATE
    }
    // TEXT
    if (form.isEmail !== "true") {
        message.smsBody = form.smsBody;
        message.sendAsSms = true;
    }
    return message;
};
// @ts-expect-error - TS7006 - Parameter 'form' implicitly has an 'any' type.
export const mapFormStateToScheduledMessages = (form) => {
    const scheduledMessage = {};
    const automatedSchedule = {};
    const dateTime = form.isRecurring === "true"
        ? DateService.getDateWithTime(form.executionDate.toDate(), form.runEveryDayTime)
        : DateService.getDateWithTime(form.sendDate.toDate(), form.sendDateTime);
    let hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    let meridiem = 0;
    if (hours > 12) {
        hours -= 12;
        if (hours === 12) {
            hours = 0;
        }
        meridiem = 1;
    }
    else if (hours === 24) {
        hours = 0;
        meridiem = 1;
    }
    automatedSchedule.hours = hours;
    automatedSchedule.interval = parseInt(form.runEveryDays, 10) || 0;
    automatedSchedule.meridiem = meridiem;
    automatedSchedule.minutes = minutes;
    scheduledMessage.automatedSchedule = automatedSchedule;
    scheduledMessage.nextExecutionDate =
        form.isRecurring === "true"
            ? DateService.display(form.executionDate)
            : DateService.display(form.sendDate);
    scheduledMessage.isDelayedMessage = form.isRecurring !== "true";
    scheduledMessage.name = form.scheduleName;
    scheduledMessage.attachmentIdsToRemove = [];
    scheduledMessage.attachmentsIdList = [];
    scheduledMessage.active = form.isRecurring !== "true" ? true : form.active;
    scheduledMessage.id = null;
    return scheduledMessage;
};
